module.exports = "/src/views/player/jobselector/assets/images/lock.svg";